import { DataBean } from "../../DataBean";


export class SignAndApprovalitem extends DataBean {

    public async getSignAndApprovalItemCatalog(idSignAndApprovalPanel: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSignAndApprovalItemCatalog_Number", [idSignAndApprovalPanel]);
    }

    public async deleteSignAndApprovalItem(idSignAndApprovalItem: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSignAndApprovalItem_Number", [idSignAndApprovalItem]);
    }

    public async updateSignAndApprovalItem(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.SignAndApprovalItem_updateSignAndApprovalItem_com.quickdataerp.bean.documents.SignAndApprovalItem", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.documents.SignAndApprovalItem"
            }
        ]);
    }

}